import Paragraphe from "./Paragraphe";

class ParagrapheVitrine extends Paragraphe {
    items = [];

    constructor(title, items) {
        super('vitrine', title);
        this.items = items;
    }
}

export default ParagrapheVitrine;